import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  getNotification,
  updateNotification,
} from "../../store/slice/notificationSlice";

const SendNotificationModal = ({
  show,
  handleClose,
  values,
  setValues,
  page_number,
}) => {
  const dispatch = useDispatch();
  const showHideClassName = show && "user_detail_modal_show";

  const { t } = useTranslation("common");

  const sendNowHandler = () => {
    const data = {
      notification_title: values.notification_title,
      notification_description: values.notification_description,
      notification_type_id: values.notification_type_id,
      user_role: JSON.parse(values.user_role),
      send_now: "1",
    };

    dispatch(
      updateNotification({
        data,
        id: values.id,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            dispatch(getNotification({ start: (page_number - 1) * 10 }));
            setValues({
              ...values,
              sendNotificationModal: false,
              sendNotificationModalData: "",
            });
          }
        },
        toast: t("toast.update_noti"),
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={handleClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            {t("modal.send.sendNotification")}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.send.sendNotificationDesc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={handleClose}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={sendNowHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("table.send")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default SendNotificationModal;
